export const NAME = 'user';

const CONTEXT = 'MODULE::PROFILE::USER';

const FETCH_START = `${CONTEXT}::FETCH::START`;
const FETCH_END = `${CONTEXT}::FETCH::END`;
const FETCH_ERROR = `${CONTEXT}::FETCH::ERROR`;

const FETCH_USER_START = `${CONTEXT}::FETCH::USER::START`;

const RESET_STATE = `${CONTEXT}::RESET::STATE`;

const FETCH = {
  START: FETCH_START,
  END: FETCH_END,
  ERROR: FETCH_ERROR,
  USER_START: FETCH_USER_START,
};

const RESET = {
  STATE: RESET_STATE,
};

export const ACTION_TYPES = {
  FETCH,
  RESET,
};
